module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full flex cursor-move idea-card",
    class: {
      'flex-col-reverse': _vm.showingImages
    }
  }, [(!_vm.showingImages) ? _c('div', {
    staticClass: "h-auto w-24 flex-none bg-cover rounded-t-none rounded-l text-center overflow-hidden bg-center",
    style: (_vm.bgImage),
    attrs: {
      "title": _vm.idea.name
    },
    on: {
      "click": _vm.showBigImages
    }
  }) : _c('div', {
    staticClass: "w-full idea-image-slider",
    on: {
      "click": function($event) {
        _vm.showingImages = false
      }
    }
  }, _vm._l((_vm.idea.images), function(image) {
    return _c('img', {
      staticStyle: {
        "max-width": "400px",
        "display": "inline"
      },
      attrs: {
        "src": image
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "w-full border-r border-t border-gray-light bg-white rounded-r p-2 flex flex-col justify-between leading-normal",
    class: {
      'border-l rounded-l': _vm.showingImages, 'border-b': !_vm.showingImages
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.removable),
      expression: "removable"
    }],
    staticClass: "close-icon text-gray-light px-2 hover:text-black",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("\n        ×\n      ")]), _vm._v(" "), _c('header', {
    staticClass: "text-black font-bold mb-1 leading-tight idea-card-header"
  }, [_vm._v("\n          " + _vm._s(_vm.idea.name) + "\n          "), _c('idea-icon', {
    attrs: {
      "idea": _vm.idea
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "3.25rem"
    }
  }, [(_vm.idea.address || _vm.idea.website) ? _c('p', {
    staticClass: "text-sm leading-tight mb-1 text-gray"
  }, [_c('a', {
    staticClass: "text-gray hover:text-gray-700 underline",
    attrs: {
      "target": "_blank",
      "href": _vm.idea.website
    }
  }, [_vm._v("Website")]), _vm._v(" "), (_vm.idea.address && _vm.idea.website) ? _c('span', [_vm._v("·")]) : _vm._e(), _vm._v(" "), (_vm.idea.address) ? _c('a', {
    staticClass: "text-gray hover:text-gray-700 no-underline hover:underline",
    attrs: {
      "target": "_blank",
      "href": _vm.idea.url
    }
  }, [_vm._v(_vm._s(_vm.idea.address))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.editingDescription) ? _c('p', {
    staticClass: "text-gray-500 text-sm leading-tight",
    staticStyle: {
      "min-height": "1rem"
    },
    on: {
      "click": function($event) {
        _vm.editingDescription = true
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.idea.description) + "\n        ")]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idea.description),
      expression: "idea.description"
    }],
    ref: "description",
    staticClass: "input-description w-full text-sm",
    domProps: {
      "value": (_vm.idea.description)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updateDescription.apply(null, arguments)
      },
      "blur": _vm.updateDescription,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.idea, "description", $event.target.value)
      }
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06370a11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IdeaCard.vue
// module id = 154
// module chunks = 1